/**
 * Protocol for third party authentication integration.
 * @interface
 */
Foundation.Login.ThirdPartyAuthenticator = function () {}


/**
 * The Foundation.Session.Manager.Delegate ID for the delegate the session
 * manager should use for this authentication method once the user is signed
 * in.
 * @return {!string}
 */
Foundation.Login.ThirdPartyAuthenticator.prototype.sessionManagerDelegateID = function () {}

/**
 * The service name, for use in UI copy. For example, "Facebook", "Twitter".
 * @return {!string}
 */
Foundation.Login.ThirdPartyAuthenticator.prototype.serviceName = function () {}


/**
 * Must authenticate the user with the 3rd party service, prompting the user to
 * log in to the third party service if they are not already. Must return a
 * Foundation.Promise that is fulfilled when the user has been authenticated,
 * and failed if authentication has been canceled by the user.
 * @return {Foundation.Promise!}
 */
Foundation.Login.ThirdPartyAuthenticator.prototype.authenticateWithThirdPartyService = function () {}

/**
 * The time-to-live (in seconds) for the authentication token. Return 0 for
 * session-based TTL (think session cookies).
 * @return {number}
 */
Foundation.Login.ThirdPartyAuthenticator.prototype.sessionTTL = function () {}

/**
 * If the third party authentication mechanism is capable of giving us the
 * user's email address, this method should return it. Return null otherwise.
 * @return {string?}
 */
Foundation.Login.ThirdPartyAuthenticator.prototype.suggestedUserEmailAddress = function () {}

/**
 * If the third party authentication mechanism gives us a potential user
 * name to suggest for the user during account creation, this method should
 * return it. Return null otherwise.
 * @return {string?}
 */
Foundation.Login.ThirdPartyAuthenticator.prototype.suggestedUserName = function () {}

/**
 * If the third party authentication mechanism gives us a potential full
 * name to suggest for the user during account creation, this method should
 * return it. Return null otherwise.
 * @return {string?}
 */
Foundation.Login.ThirdPartyAuthenticator.prototype.suggestedUserFullName = function () {}

/**
 * Must attempt to find the Foundation Member object that the user is logged
 * in under for this service. This method must not prompt the user to log in.
 * If the user is not already authenticated, the returned promise must be failed.
 * If no such Member object could be found with the user's authentication
 * credentials, the returned promise must be failed. If one is found, the returned
 * promise must be fulfilled.
 * @return {Foundation.Promise!}
 */
Foundation.Login.ThirdPartyAuthenticator.prototype.authenticateWithFoundation = function () {}


/**
 * This method is called just before creating a new Member object, or linking
 * an existing member object to the third-party authentication services, giving
 * the authenticator implementation a chance to set some extra info in the
 * Member object. It should return a promise that is fulfilled once the
 * decorating is complete, or is failed if there are errors.
 * @param {Foundation.Member!} theMember
 * @return {Foundation.Promise!}
 */
Foundation.Login.ThirdPartyAuthenticator.prototype.decorateMember = function (theMember) {}

/**
 * Returns the objId for the Member object that the user has been authenticated
 * as during the authenticateWithFoundation call.
 * @return {number}
 */
Foundation.Login.ThirdPartyAuthenticator.prototype.memberOid = function () {}

/**
 * Returns the UserName from the Member object that the user has been
 * authenticated as during the authenticateWithFoundation call.
 * @return {string}
 */
Foundation.Login.ThirdPartyAuthenticator.prototype.memberUserName = function () {}

/**
 * Returns the URL to use for the avatar image for the Member that the user
 * has been authenticated as during the authenticateWithFoundation call.
 * @return {string}
 */
Foundation.Login.ThirdPartyAuthenticator.prototype.memberAvatarUrl = function () {}

/**
 * Must return whether or not it is likely that there is an existing Member
 * object in the database that will cause a collision. Basically, does a
 * user exist with the email address we may have gotten from the third
 * party authentication. Note that this method only gets called after
 * authenticateWithFoundation is completed, so that's a good time to check.
 * @return {boolean}
 */
Foundation.Login.ThirdPartyAuthenticator.prototype.accountIsLikelyToCollide = function () {}

/**
 * Must attempt to link the authenticated Foundation Member object with the
 * third party authentication credentials. For example, setting the FacebookId
 * value on the Member object. From the client-side perspective, it can be assumed
 * that if this method is called the browser will have a valid foundation-login
 * cookie set. (You'll want to validate the foundation-login cookie on the
 * server side before updating the Member object with the link, of course.)
 * The method must return a Foundation.Promise that is fulfilled on success,
 * and failed if there was an error completing the link.
 * @return {Foundation.Promise!}
 */
Foundation.Login.ThirdPartyAuthenticator.prototype.linkLoggedInMemberWithThirdPartyCredentials = function () {}

/**
 * Called when the user cancels the creation of the account partway through the
 * account creation flow. This is where you should reverse any changes you
 * may have made. For example, removing the app from a user's Facebook account.
 * Returns a Foundation.Promise that must be fulfilled when complete, and failed
 * if there was an error backing out the changes. If there is nothing to be undone,
 * just return null.
 * @return {Foundation.Promise?}
 */
Foundation.Login.ThirdPartyAuthenticator.prototype.userCanceledAccountCreation = function () {}

/* eslint no-unused-vars: "off" */
